import { Pipe, PipeTransform } from '@angular/core'
import { WeatherStatusService } from '../services/weather-status.service'

@Pipe({
    name: 'windDirectionByDegree',
    standalone: false
})
export class WindDirectionByDegreePipe implements PipeTransform {
  constructor(private service: WeatherStatusService) {}

  transform(degree: number | null, separator: string = '-'): string {
    if (degree === null) {
      return separator
    }
    return this.service.getWindDirectionBySection(this.service.getWindSectionByDegree(degree))
  }
}
